import React, { createContext, useReducer } from 'react'
import { retrieveAnalytics } from '../../services/firebase'
import { SET_STATISTICS } from '../types'
import statisticsReducer from './statisticsReducer'

const StatisticsContext = createContext()

// eslint-disable-next-line react/prop-types
const StatisticsState = ({ children }) => {

  const initialState = {
    aggregate: null,
    days: [],
    statisticsUpdatedAt: false,
    statisticsLoaded: false,
  }

  const [state, dispatch] = useReducer(statisticsReducer, initialState)

  const fetchStatistics = async ({ force = false } = {}) => {
    // fetch analytics from Firebase Storage instead of Firestore to avoid hitting the Firestore read limits
    const analyticsData = await retrieveAnalytics({ force: force ?? false })

    dispatch({
      type: SET_STATISTICS,
      payload: analyticsData ?? { aggregate: null, days: [], updated: 0 },
    })
    return analyticsData
  }

  return (
    <StatisticsContext.Provider value={{
      aggregate: state.aggregate,
      days: state.days,
      statisticsLoaded: state.statisticsLoaded,
      statisticsUpdatedAt: state.statisticsUpdatedAt,
      fetchStatistics,
    }}>
      { children }
    </StatisticsContext.Provider>
  )
}

export { StatisticsContext }

export default StatisticsState